import { useMutation } from '@tanstack/react-query'
import { useHistory } from 'react-router-dom'
import { useAuthStore } from '../../../zustand/authentication/use-auth-store'
import { authMutationKeys } from '../constants'

export const useLoginSamlMutation = () => {
  const { loginSuccessful, logout } = useAuthStore()
  const history = useHistory()

  const handleMutation = async ({ credentials }) => {
    try {
      loginSuccessful(credentials)

      const redirectTo = localStorage.getItem('redirectTo')
      if (redirectTo) {
        localStorage.removeItem('redirectTo')
        return history.replace(redirectTo)
      }

      history.replace('/')
    } catch (error) {
      logout()
      throw error
    }
  }

  return useMutation({
    mutationFn: handleMutation,
    mutationKey: authMutationKeys.SAML_MUTATION,
    retry: false
  })
}
